module.exports = __webpack_public_path__ + "static/media/no-sessions.b06960b0.png";